import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import BreadCrumbs from '../components/page/BreadCrumbs';
import HtmlHelmet from '../components/common/HtmlHelmet';

const AuthWrapper = ({ children, title, meta, breadcrumbs, activeTab }) => {
    const history = useHistory();

    return (
        <Fragment>
            <HtmlHelmet custom_meta={meta} />
            <BreadCrumbs bread_curmbs={breadcrumbs} />
            <section className="sign-in">
                <div className="container">
                    <div className="form-title mb-4">
                        <h3 className="text-center">{title}</h3>
                    </div>

                    <style>{`
                        .auth-tab-btn:hover {
                            color: white !important;
                            background-color: #004E8F !important;
                        }
                    `}</style>

                    <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginBottom: '24px' }}>
                        <button
                            type="button"
                            className={`btn auth-tab-btn ${activeTab === 'office' ? 'btn-primary' : 'btn-outline-primary'}`}
                            style={{
                                minWidth: '140px',
                                backgroundColor: activeTab === 'office' ? '#004E8F' : '',
                                borderColor: '#004E8F',
                                color: activeTab === 'office' ? 'white' : '#004E8F'
                            }}
                            onClick={() => history.push('/login-office')}
                        >
                            Financial Associate
                        </button>
                        <button
                            type="button"
                            className={`btn auth-tab-btn ${activeTab === 'policyholder' ? 'btn-primary' : 'btn-outline-primary'}`}
                            style={{
                                minWidth: '140px',
                                backgroundColor: activeTab === 'policyholder' ? '#004E8F' : '',
                                borderColor: '#004E8F',
                                color: activeTab === 'policyholder' ? 'white' : '#004E8F'
                            }}
                            onClick={() => history.push('/login-customer')}
                        >
                            Policy Holder
                        </button>
                        <button
                            type="button"
                            className={`btn auth-tab-btn ${activeTab === 'employee' ? 'btn-primary' : 'btn-outline-primary'}`}
                            style={{
                                minWidth: '140px',
                                backgroundColor: activeTab === 'employee' ? '#004E8F' : '',
                                borderColor: '#004E8F',
                                color: activeTab === 'employee' ? 'white' : '#004E8F'
                            }}
                            onClick={() => history.push('/login-employee')}
                        >
                            Employee/UM/BM
                        </button>
                    </div>

                    <div className="sign-in-form" style={{ maxWidth: '500px', margin: '0 auto 40px' }}>
                        {children}
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

export default AuthWrapper;
